import useStyles from './homepage.styles';

import Stepper from '../../components/home-stepper';
import JustInPreview from '../../components/just-in-preview';
import ShopByPetPreview from '../../components/shop-by-pet-preview';
import SpecialPreview from '../../components/special-preview';
import FeaturedBrandPreview from '../../components/featured-brand-preview';
import Footer from '../../components/footer';

const HomePage = () => {
  const classes = useStyles();

  return (
    <div className={classes.home}>
      <Stepper />
      <JustInPreview />
      <ShopByPetPreview />
      <SpecialPreview />
      <FeaturedBrandPreview />
      <Footer />
    </div>
  );
};

export default HomePage;
